const safeToString = (value: unknown): string => {
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean' || value === null) return String(value)

  if (value instanceof Error) {
    return value.stack || `${value.name}: ${value.message}`
  }

  // Avoid JSON.stringify failures breaking the logger.
  try {
    if (typeof value === 'object') return JSON.stringify(value)
  } catch {
    // ignore
  }

  return String(value)
}

export const formatConsoleArgs = (args: unknown[]): { message: string; argsPreview: string[] } => {
  const argsPreview = args.map(safeToString)
  const message = argsPreview.join(' ')
  return { message, argsPreview }
}

